module.exports = __webpack_public_path__ + "static/img/Home68@2x.2ccaa4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home68@2x.png
// module id = WhlF
// module chunks = 1